import { DateTime } from "luxon";
import { useState } from "react";
import FormGroup from "./FormGroup";
import AddIconButton from "../components/AddIconButton";
import DeleteIconButton from "../components/DeleteIconButton";

const WeekSelector = (props) => {
    const { defaultWeeks, refreshPreview } = props;

    const [weeks, setWeeks] = useState(defaultWeeks);

    const updateYear = (weekIndex, value) => {
        const data = [...weeks];
        data[weekIndex].year = value;

        const d = DateTime.fromFormat(`${data[weekIndex].year} ${data[weekIndex].week}`, 'kkkk W');
        data[weekIndex].date = d;
        setWeeks(data);
        refreshPreview(data);
    }
    const updateWeek = (weekIndex, value) => {
        const data = [...weeks];
        data[weekIndex].week = value;

        const d = DateTime.fromFormat(`${data[weekIndex].year} ${data[weekIndex].week}`, 'kkkk W');
        data[weekIndex].date = d;
        setWeeks(data);
        refreshPreview(data);
    }

    const removeWeek = (weekIndex) => {
        const data = [...weeks];
        data.splice(weekIndex, 1);
        setWeeks(data);
        refreshPreview(data);
    }

    const addWeek = () => {
        const d = DateTime.fromFormat(`${weeks[weeks.length - 1].year} ${weeks[weeks.length - 1].week}`, 'kkkk W');
        const dd = d.plus({ week: 1 })
        console.log(d);
        const data = [...weeks, { year: dd.toFormat('kkkk'), week: dd.toFormat('W'), date: dd}];
        setWeeks(data);
        refreshPreview(data);
    }

    return <FormGroup labelKey="weeksSelector" label="Selected Weeks">
        <div className="overflow-y-auto max-h-56 rounded bg-gray-50 border border-gray-300 shadow-inner shadow-sm p-2">
            {weeks.map((weekConfig, yi) => (
                <div key={yi} className="flex flex-row items-middle grow">

                    <input type="text" style={{ width: '70px' }} className="border my-1 mr-2 py-2 px-3 text-grey-darkest" value={weekConfig.year} onChange={event => updateYear(yi, event.target.value)} />
                    <input type="text" style={{ width: '70px' }} className="border my-1 py-2 px-3 text-grey-darkest" value={weekConfig.week} onChange={event => updateWeek(yi, event.target.value)} />

                    <div className="w-1/3 my-1 p-2 flex justify-items-stretch">
                        {weeks.length > 1 && <div className="justify-self-end">
                            <DeleteIconButton onClick={() => removeWeek(yi)} />
                        </div>}
                        {weeks.length === 1 && <div style={{ width: '30px' }}></div>}
                    </div>
                </div>
            ))}

            <div className="w-1/3 flex justify-items-stretch my-4 mx-1">
            <div className="justify-self-end">
                <AddIconButton onClick={addWeek} />
            </div>
        </div>
        </div>
        
    </FormGroup>
}

export default WeekSelector;